export default {
  "pl": {
    "survey_type": {
      "actions": {
        "changeResponsible": "Zmień osobę odpowiedzialną"
      },
      "attributes": {
        "responsible": "Osoba odpowiedzialna"
      },
      "labels": {
        "editInternalTitle": "Zmienić tytuł do użytku wewnętrznego?",
        "explainerNPSPart1": "Net Promoter Score to statystyka, która pozwala określić, w jakim stopniu – w skali od -100 do 100 – klient jest skłonny polecać innym twoją firmę lub projekty.",
        "explainerOpinionScale": "Określ podejście klientów, posługując się ogólnym stwierdzeniem.",
        "moreInfo": "Więcej informacji",
        "nps": "Net Promoter Score",
        "npsQuestion": "NPS",
        "opinionScale": "Skala opinii",
        "preview": "Podgląd"
      },
      "navigation": {
        "backToSurveyTypes": "Powrót do ankiet"
      },
      "toasts": {
        "bulk_delete": "Ankieta została usunięta | Ankiety zostały usunięte",
        "update": "Ankieta została zaktualizowana"
      },
      "validation": {
        "selectSurveyType": "Wybierz przynajmniej 1 ankietę"
      }
    }
  }
}
